"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDesignTokenValue = void 0;
const logger_1 = require("../helpers/logger");
const get_1 = require("../helpers/get");
const create_css_var_name_1 = require("./create-css-var-name");
const example_design_tokens_1 = require("./example-design-tokens");
function getDesignTokenValue(propertyPath = '', tokensOverride) {
    if (!propertyPath) {
        (0, logger_1.warnWithTrace)(`Design token value could not be found: ${propertyPath}`);
        return undefined;
    }
    const designTokenValue = (0, get_1.get)(tokensOverride || example_design_tokens_1.designTokens, propertyPath);
    // propertyPath is probably already resolved, comes from the tokens package...
    if (!designTokenValue) {
        return propertyPath;
    }
    // array values, return css var instead
    // the assumption is that every array is a dynamic designToken
    if (Array.isArray(designTokenValue)) {
        return `var(${(0, create_css_var_name_1.createCSSVarName)(propertyPath)})`;
    }
    return designTokenValue;
}
exports.getDesignTokenValue = getDesignTokenValue;
